(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  (() => {
    if (window.collectionBrandSearchReady) return;
    window.collectionBrandSearchReady = true;

    const timers = new WeakMap();
    const controllers = new WeakMap();

    const closeResults = (input) => {
      const results = input.closest('[data-collection-brand-toolbar]')?.querySelector('[data-collection-brand-search-results]');
      if (!results) return;
      results.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    };

    const renderResults = (input, products) => {
      const toolbar = input.closest('[data-collection-brand-toolbar]');
      const results = toolbar?.querySelector('[data-collection-brand-search-results]');
      if (!results) return;

      results.replaceChildren();

      if (products.length === 0) {
        const empty = document.createElement('div');
        empty.className = 'collection-brand-search__empty';
        empty.textContent = results.dataset.emptyText;
        results.appendChild(empty);
      } else {
        const fragment = document.createDocumentFragment();
        products.forEach((product) => {
          const link = document.createElement('a');
          link.className = 'collection-brand-search__result';
          link.href = product.url;
          link.setAttribute('role', 'option');

          if (product.image) {
            const image = document.createElement('img');
            image.src = product.image;
            image.alt = '';
            image.loading = 'lazy';
            link.appendChild(image);
          }

          const title = document.createElement('span');
          title.textContent = product.title;
          link.appendChild(title);
          fragment.appendChild(link);
        });
        results.appendChild(fragment);
      }

      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };

    document.addEventListener('input', (event) => {
      const input = event.target.closest('[data-collection-brand-search]');
      if (!input) return;

      const query = input.value.trim();
      window.clearTimeout(timers.get(input));
      controllers.get(input)?.abort();

      if (query.length < 2) {
        closeResults(input);
        return;
      }

      const timer = window.setTimeout(async () => {
        const controller = new AbortController();
        controllers.set(input, controller);
        const toolbar = input.closest('[data-collection-brand-toolbar]');
        const brandName = toolbar?.dataset.brandName?.toLowerCase() || '';
        const root = window.Shopify?.routes?.root || '/';
        const url = `${root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10`;

        try {
          const response = await fetch(url, { signal: controller.signal });
          if (!response.ok) throw new Error(`Search request failed with ${response.status}`);
          const data = await response.json();
          const products = data.resources?.results?.products || [];
          const matchingProducts = products
            .filter((product) => {
              const title = product.title?.toLowerCase() || '';
              const vendor = product.vendor?.toLowerCase() || '';
              return brandName === '' || title.includes(brandName) || vendor.includes(brandName);
            })
            .slice(0, 5);
          renderResults(input, matchingProducts);
        } catch (error) {
          if (error.name !== 'AbortError') closeResults(input);
        }
      }, 180);

      timers.set(input, timer);
    });

    document.addEventListener('click', (event) => {
      document.querySelectorAll('[data-collection-brand-search]').forEach((input) => {
        if (!input.closest('[data-collection-brand-toolbar]')?.contains(event.target)) closeResults(input);
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const input = event.target.closest('[data-collection-brand-search]');
      if (input) closeResults(input);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
